import { Reducer } from "redux";
import { Action, ActionType } from "../../../actions";
import { RemarksTableData } from "../../../state/BookingCreateManagerV2/Remarks/TableData";

const updateRemarksTableData: Reducer<RemarksTableData> = (
  state: RemarksTableData = new RemarksTableData(),
  action: Action<ActionType, RemarksTableData>
) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_V2_REMARKS_TABLE_DATA_FETCHED:
      return {
        ...state,
        records: action.data.items,
        totalItems: action.data.totalItems,
      };
    case ActionType.BOOKING_CREATE_MANAGER_V2_REMARKS_TABLE_DATA_ROW_DELETED:
      let newRuleList = state.records.filter(
        (item) => item.id !== action.data.id
      );
      return { ...state, records: newRuleList };
    default:
      return state;
  }
};

export default updateRemarksTableData;
